import useChatContext from 'hooks/useChatContext';
import { Box, Stack, Typography } from '@mui/material';

import { useSelector } from 'react-redux';

// assets
import IconButton from 'components/@extended/IconButton';
import CloseIcon from '@mui/icons-material/Close';

function ReplyMessage() {
	const { reply, setReply, selectedUser } = useChatContext();
	const userId = useSelector((state) => state.auth.userId);

	if (reply) {
		let replyMessageUserName;

		if (reply?.senderId && selectedUser?.otherUserId && selectedUser?.entityFullName) {
			replyMessageUserName = reply?.senderId === selectedUser?.otherUserId ? selectedUser?.entityFullName : 'You';
		} else {
			replyMessageUserName = reply?.userId === userId ? 'You' : reply?.userFrom?.entityFullName;
		}

		return (
			<Box sx={{ order: 3, px: { xs: 2, md: 5 }, py: 1, bgcolor: '#f2f2f2' }}>
				<Stack direction="row" alignItems="center">
					<Box
						sx={{ width: '100%', maxHeight: '68px', overflow: 'hidden', bgcolor: '#ffffff', borderRadius: '10px', py: '5px', px: '10px' }}
					>
						<Stack>
							<Typography variant="h5" color="text.primary">
								{replyMessageUserName}
							</Typography>
							<Typography component="span" color="textSecondary" variant="caption">
								{reply?.message}
							</Typography>
						</Stack>
					</Box>
					<Box>
						<IconButton color="secondary" sx={{ width: '48px', height: '48px' }} onClick={() => setReply(null)}>
							<CloseIcon />
						</IconButton>
					</Box>
				</Stack>
			</Box>
		);
	}

	return null;
}

export default ReplyMessage;
